import * as React from 'react';
import  './planner.scss';
import {CPlannerTask} from '../../Entity/PlannerTaskObj';
import PlannerTask from './plannertask';
import {User} from '../../Entity/User';

export interface IProps{
    tasks:CPlannerTask[];
    Users:User[];
    Loadpic;
    UpdateData;
    UserEmail;
    Language;
    Header;
    Phrases;
    ReloadPlannerTasks;
    Progress;
    APIHeader;
    APIServiceurl;
    CurrentUser;
}
export default class PlannerTasks extends React.Component<IProps> {
    constructor(props) {
        super(props);
      }
    public render() {
       
        return (

         <div className='Planner'>      
             {this.props.tasks.map((obj, index)=> {
                    let keyval='Plannerlist_'+obj.id;
                    //let keyval=obj.id;
                    return (
                                <PlannerTask 
                                    data={obj} 
                                    key={keyval} 
                                    // key={obj.id} 
                                    Users={this.props.Users} 
                                    Loadpic={this.props.Loadpic}
                                    UpdateData={this.props.UpdateData}
                                    UserEmail={this.props.UserEmail}
                                    Language={this.props.Language}
                                    Header={this.props.Header}
                                    Phrases={this.props.Phrases}
                                    ReloadPlannerTasks={this.props.ReloadPlannerTasks}
                                    Progress={this.props.Progress}
                                    APIHeader={this.props.APIHeader}
                                    APIServiceurl={this.props.APIServiceurl}
                                    CurrentUser={this.props.CurrentUser}
                                />
                            );
                  })}
         </div>
        );
      }
}